<script lang="js">
import * as noticeApi from '@/api/notice'
import MessageContent from '@/components/MessageContent'

export default {
  name: 'notice-history-detail',
  components: { MessageContent },
  data: function () {
    return {
      /**
       * @type {number}
       */
      noticeHistoryId: undefined,
      /**
       * @type {import('../../types/api').NoticeHistoryItem}
       */
      noticeHistory: undefined,
      // 通知历史消息表格列
      eventColumns: [
        {
          title: '级别',
          dataIndex: 'level',
          key: 'level',
          scopedSlots: { customRender: 'level' }
        },
        {
          title: '系统',
          dataIndex: 'system',
          key: 'system'
        },
        {
          title: '模块',
          dataIndex: 'module',
          key: 'module'
        },
        {
          title: '部门',
          dataIndex: 'department',
          key: 'department'
        },
        {
          title: '消息',
          dataIndex: 'message',
          key: 'message',
          width: 300,
          scopedSlots: { customRender: 'message' }
        },
        {
          title: '通知时间',
          dataIndex: 'create_time',
          key: 'create_time'
        },
        {
          title: '收件人',
          dataIndex: 'receiver_username',
          key: 'receiver_username'
        },
        {
          title: '消息组',
          dataIndex: 'group_id',
          key: 'group_id'
        }
      ],
      loading: false,
      dialogVisible: false,
      selectedMessage: ''
    }
  },
  mounted: function () {
    this.noticeHistoryId = Number.parseInt(this.$route.params.id)
    this.loadNoticeHistoryDetail()
  },
  methods: {
    loadNoticeHistoryDetail: async function () {
      if (this.noticeHistoryId) {
        this.loading = true
        try {
          const body = await noticeApi.getNoticeHistory(this.noticeHistoryId)
          this.noticeHistory = body.data
        } finally {
          this.loading = false
        }
      }
    },
    showMessageDetail(message) {
      this.selectedMessage = message
      this.dialogVisible = true
    },
    goBack() {
      const query = this.$route.query
      if (query.from === 'notice-history') {
        this.$router.push({
          path: '/notice-history',
          query: {
            page: query.page,
            channel_name: query.channel_name,
            status: query.status,
            start_time: query.start_time,
            end_time: query.end_time
          }
        })
      } else {
        this.$router.back()
      }
    }
  },
  computed: {},
  watch: {
    // eslint-disable-next-line no-unused-vars
    '$route.params.id': function (newVal, oldVal) {
      this.noticeHistoryId = newVal
      this.loadNoticeHistoryDetail()
    }
  }
}
</script>

<template>
  <div class="notice-history-detail">
    <div style="margin-bottom: 20px">
      <a-button type="primary" icon="arrow-left" @click="goBack">返回</a-button>
    </div>
    <a-descriptions title="通知历史详情">
      <a-descriptions-item label="编号">{{ noticeHistory?.id }}</a-descriptions-item>
      <a-descriptions-item label="创建时间">{{ noticeHistory?.create_time }}</a-descriptions-item>
      <a-descriptions-item label="完成时间">{{ noticeHistory?.done_time }}</a-descriptions-item>
      <a-descriptions-item label="通道编号">{{ noticeHistory?.channel_id }}</a-descriptions-item>
      <a-descriptions-item label="通道名称">{{ noticeHistory?.channel_name }}</a-descriptions-item>
      <a-descriptions-item label="网关">{{ noticeHistory?.gateway }}</a-descriptions-item>
      <a-descriptions-item label="状态">
        <a-tag v-if="noticeHistory?.status === 1" color="green">成功</a-tag>
        <a-tag v-else-if="noticeHistory?.status === 2" color="red">失败</a-tag>
        <a-tag v-else color="blue">发送中</a-tag>
      </a-descriptions-item>
      <a-descriptions-item label="结果">
        <message-content type="text" :content="noticeHistory?.result" />
      </a-descriptions-item>
    </a-descriptions>
    <div class="detail-section-title">通知历史消息</div>
    <a-table :data-source="noticeHistory?.event_list" :columns="eventColumns" :row-key="row => row.id" :loading="loading" :pagination="false" bordered>
      <template slot="level" slot-scope="text, record">
        <a-tag :color="record.level === 'INFO' ? 'green' : record.level === 'WARN' ? 'orange' : record.level === 'ERROR' ? 'red' : undefined"
          >{{ text }}
        </a-tag>
      </template>
      <template slot="message" slot-scope="text, record">
        <div class="message-cell">
          <message-content mode="inline" :content="text" />
          <a-button type="link" size="small" icon="fullscreen" @click="showMessageDetail(record.message)">展开</a-button>
        </div>
      </template>
    </a-table>

    <a-modal title="消息详情" :visible="dialogVisible" width="60%" :mask-closable="false" @cancel="dialogVisible = false">
      <div class="message-detail-content">
        <message-content :content="selectedMessage" />
      </div>
      <template slot="footer">
        <a-button @click="dialogVisible = false">关闭</a-button>
      </template>
    </a-modal>
  </div>
</template>

<style scoped>
/* a-table 默认 auto 布局，单元格宽度由内容决定，长消息会把表格撑宽；固定布局后按列宽截断 */
.notice-history-detail ::v-deep .ant-table table {
  table-layout: fixed;
}

.message-cell {
  display: flex;
  align-items: center;
  gap: 8px;
}

.message-cell .msg-content {
  flex: 1;
  min-width: 0;
}

.message-detail-content {
  padding: 16px;
  background-color: #f5f7fa;
  border-radius: 4px;
  line-height: 1.6;
  max-height: 500px;
  overflow-y: auto;
}
</style>
